/* eslint-disable prettier/prettier */
export default {
  label: {
    ok: 'ശരി',
    confirm: 'കൺഫോം',
    cancel: 'റദ്ദാക്കുക',
    download: 'ഡൗൺലോഡ്',
    submit: 'സമർപ്പിക്കുക',
    search: 'തിരയുക',
    recharge: 'റീചാർജ്',
    balance: 'ബാലൻസ്',
  },
  tip: {
    success: 'വിജയകരമായി പൂർത്തികരിച്ചു',
  },
  text: {},
  defaultPage: {
    noMore: 'കൂടുതൽ ഡാറ്റ ഇല്ല',
  },
  home: {
    scratchOff: 'സ്ക്രാച്ച് ഓഫ്',
    copied: 'പകർത്തുക',
    tip: {
      beforDownload: 'ദയവായി രജിസ്റ്റർ ചെയ്യുക അല്ലെങ്കിൽ ലോഗിൻ ചെയ്യുക',
    },
  },
  alert: {
    logout: 'ലോഗ് ഔട്ട്',
    sureLogout: 'നിങ്ങൾക് ലോഗ് ഔട്ട് ചെയ്യണമെന്ന് തീർച്ചയാണോ?',
  },
  warning: {
    unopen: 'ഇതുവരെ പ്രവർത്തനക്ഷമമാക്കിയിട്ടില്ല',
  },
  notification: {
    title: 'തലക്കെട്ട്',
    announcements: 'പ്രഖ്യാപനങ്ങൾ',
    systemMessage: 'സിസ്റ്റം സന്ദേശങ്ങൾ',
  },
  vip: {
    currentLevel: 'ഇപ്പോഴത്തെ അവസ്ഥ',
    collected: 'ശേഖരിയ്ക്കുക',
    finished: 'പൂർത്തിയാക്കുക',
    received: 'ലഭിച്ചു',
    recharge: 'റീചാർജ്',
    move: 'കൂടുതൽ ലെവലിൽ എത്താൻ',
    title: 'വിഐപി',
    label: {
      reward: 'VIP ലെവൽ റിവാർഡ്',
      weekCard: 'പ്രതിവാര കാർഡ',
      weekReward: 'പ്രതിവാര വിഐപി റിവാർഡ്',
      withdrawAmount: 'പിൻവലിക്കൽ തുക',
      withdrawTimes: 'പിൻവലിക്കൽ സമയങ്ങൾ',
      withdrawFee: 'പിൻവലിക്കൽ ഫീസ്',
      silverWeekCard: 'സിൽവർ വീക്ക്‌ലി കാർഡ്',
      goldWeekCard: 'ഗോൾഡ് വീക്ക്‌ലി കാർഡ്',
      diamondWeekCard: 'ഡയമണ്ട് വീക്ക്‌ലി കാർഡ്',
      day: 'ദിവസം',
      rewardDetails: 'റിവാർഡ് വിശദാംശങ്ങൾ',
      rewardAccumulation: 'റിവാർഡ് ശേഖരണം',
      vipUpgrade: 'VIP അപ്ഗ്രേഡ്',
      buyWeekCard: 'പ്രതിവാര കാർഡ് വാങ്ങൽ അവകാശം',
      weekCardRecharge: 'പ്രതിവാര കാർഡ് റീചാർജ്',
      weekCardBuyRecord: 'പ്രതിവാര കാർഡ് വാങ്ങൽ റെക്കോർഡ്',
    },
    tip: {
      levelDetail: {
        t01: 'VIP ലെവൽ റിവാർഡ്',
        p1: 'ഒറ്റത്തവണ റിവാർഡ് ലഭിക്കാൻ VIP ലെവൽ <0>{{level}}</0>-ൽ എത്തുക.',
        t02: 'പ്രതിവാര വിഐപി റിവാർഡ്',
        p2: 'പ്രതിവാര അടിസ്ഥാന റിവാർഡുകൾ <0>{{money}}</0> ലഭിക്കാൻ <0>{{level}}</0> ലെവലിൽ എത്തുക. നിക്ഷേപങ്ങൾ, വാതുവയ്പ്പ്, സജീവമായിരിക്കുക എന്നിവയിലൂടെ നിങ്ങൾക്ക് റിവാർഡ് ഗുണിതം വർദ്ധിപ്പിക്കാൻ കഴിയും.',
        t03: 'വിഐപി പിൻവലിക്കൽ',
        p3: 'വിഐപി ലെവൽ <0>{{level}}</0>-ൽ, ഓരോ പിൻവലിക്കലിനും പരമാവധി തുക <0>{{money}}</0> ആണ്.',
        t04: 'വിഐപി പിൻവലിക്കൽ ആവൃത്തി',
        p4: 'വിഐപി ലെവൽ <0>{{level}}</0>-ൽ, നിങ്ങൾക്ക് ഒരു ദിവസം പരമാവധി <0>{{count}}</0> തവണ പിൻവലിക്കാം.',
        t05: 'വിഐപി പിൻവലിക്കൽ ഫീസ്',
        p5: 'v.വിഐപി ലെവൽ <0>{{level}}</0>-ൽ, ഓരോ ഇടപാടിനും പിൻവലിക്കൽ ഫീസ് <0>{{money}}</0> വരെ കുറവാണ് .',
      },
      remainTime: 'പ്രതിവാര കാർഡ് ശേഷിക്കുന്ന സമയം:',
      upgrade: {
        to: 'ഞങ്ങളുടെ വിലപ്പെട്ട വിഐപിക്ക്:',
        subtitle:
          'നിങ്ങളുടെ തുടർച്ചയായ പിന്തുണയാണ് ഞങ്ങളെ മുന്നോട്ട് നയിക്കുന്നത്! ഈ സിസ്റ്റം അപ്‌ഗ്രേഡിലൂടെ, നിങ്ങൾക്ക് ഇവ ആസ്വദിക്കാം:',
        li1: ' സ്മൂത്ത്  എക്സ്ക്ലൂസീവ് സെർവിസ്സ',
        li2: 'പുത്തൻ VIP സവിശേഷതകൾ',
        li3: 'ഞങ്ങളുടെ നന്ദി സൂചകമായി, ഞങ്ങൾ നിങ്ങൾക്ക് ഒരു പ്രത്യേക അപ്‌ഗ്രേഡ് സമ്മാന പാക്കേജ് നൽകുന്നു!',
      },
      weekCardReward: {
        title: 'പ്രതിവാര കാർ ഡി റിവാർഡുകൾ',
        p1: 'പ്രതിവാര കാർ ഡി റിവാർഡുകൾ: ഉപയോഗ സാഹചര',
        p2: '(യം: സാധുവായ പ്രതിവാര കാർഡ് കാലയളവിൽ പോപ്പ്അപ്പ് റിവാർഡുകൾ)',
      },
      weekCard: {
        p1: 'ഒറ്റത്തവണ റിവാർഡ് ലഭിക്കാൻ VIP ലെവൽ <0>{{money}}</0> ൽ എത്തുക.',
        p2: 'പ്രതിവാര വിഐപി റിവാർഡ്:',
        p3: 'ലഭിച്ച ആകെ മൂല്യം: <0>{{money}}</0>',
      },
      weekReward: {
        title: '<0>പ്രതിവാര വിഐപി റിവാർഡ്</0>',
        t1: 'ഇതാ നിങ്ങളുടെ ആഴ്ചതോറുമുള്ള VIP റിവാർഡുകൾ',
        t2: 'നിങ്ങളുടെ റിവാർഡുകൾ എങ്ങനെ വർദ്ധിപ്പിക്കാം?',
        p1: 'നിങ്ങളുടെ ആപ്പിലെ പ്രവർത്തനത്തെ ആശ്രയിച്ചിരിക്കും VIP റിവാർഡുകൾ . നിക്ഷേപങ്ങൾ, വാതുവയ്പ്പ്, ഇടപെടൽ എന്നിവ നിങ്ങളുടെ ഗുണിതം വർദ്ധിപ്പിക്കുന്നു.',
        p2: 'ഓരോ ഉപയോക്താവിനും <0>{{money}}</0>-ത്തിലധികം റിവാർഡുകൾ നേടാൻ അവസരമുണ്ട്!',
        yourReward: 'കഴിഞ്ഞ ആഴ്ചയിലെ നിങ്ങളുടെ റിവാർഡ',
      },
      weeklyRemain: 'നിങ്ങളുടെ പ്രതിവാര കാർഡ് ശേഷിക്കുന്നു',
      confirmBuyTitle: 'പ്രതിവാര കാർഡ് വാങ്ങുക',
      confirmBuy: '{{type}} പ്രതിവാര കാർഡ് വാങ്ങാൻ സ്ഥിരീകരിക്കണോ?',
      weekCardBuySuccess: '{{type}} പ്രതിവാര കാർഡ് വിജയകരമായി വാങ്ങുക',
      noVip:
        'പ്രതിവാര കാർഡ് VIP ഉപയോക്താക്കൾക്ക് മാത്രമേ വാങ്ങാൻ പിന്തുണയ്ക്കൂ, ദയവായി അപ്‌ഗ്രേഡ് ചെയ്യുക',
    },
    rules: {
      title: 'വിഐപി പ്രതിവാര കാർഡ് ഉപയോഗ നിയമങ്ങൾ ',
      subtitle1: 'എന്താണ് വിഐപി വീക്ക്‌ലി പാസ്?',
      sub1paragraph1:
        'എക്സ്ക്ലൂസീവ് പ്രിവിലേജ്: വിഐപികൾക്ക് മാത്രം ലഭ്യമാണ് ഉപയോക്താക്കൾ, വാങ്ങിയ ഉടൻ തന്നെ പ്രാബല്യത്തിൽ വരും',
      sub1paragraph2:
        'സാധുത കാലയളവ്: ഓരോ ആഴ്ച കാർഡും **7 സ്വാഭാവിക ദിവസങ്ങൾ** നീണ്ടുനിൽക്കും (നീട്ടാവുന്നതാണ്)',
      subtitle2: ' ഡബിൾ റെൻഡസ്',
      sub2paragraph1:
        'റീചാർജ് തുകയ്ക്ക് തുല്യമായ മൂല്യം(ഉദാ: 30 പോയിന്റുകൾ ലഭിക്കാൻ 30 രൂപ റീചാർജ് ചെയ്യുക)',
      sub2paragraph2:
        'സാധുത കാലയളവ്: ഓരോ ആഴ്ച കാർഡും**7 സ്വാഭാവിക ദിവസങ്ങൾ** (നീട്ടാവുന്നതാണ്)',
      subtitle3: 'റിവാർഡ് ശേഖരണ',
      sub3paragraph1:
        ' എല്ലാ ദിവസവും ലോഗിൻ ചെയ്യുക, ആ ദിവസം റിവാർഡുകൾ സ്വയമേവ വിതരണം ചെയ്യപ്പെടും. നിങ്ങൾ ലോഗിൻ ചെയ്തില്ലെങ്കിൽ, റിവാർഡുകൾ മാറ്റിവയ്ക്കപ്പെടും.അടുത്ത ദിവസത്തേക്ക്.',
      sub3paragraph2:
        'കാലാവധി കഴിഞ്ഞാൽ റിഡീം ചെയ്യാൻ കഴിയില്ല: പ്രതിവാര കാർഡ് കാലഹരണപ്പെട്ടതിന് ശേഷം ക്ലെയിം ചെയ്യാത്ത റിവാർഡുകൾ അസാധുവായിരിക്കും.',
      subtitle4: 'ഓവർലേ പ്രിവിലേജുകൾ',
      sub4paragraph1:
        'ഒരേ തരത്തിലുള്ള ആഴ്ചയിലെ പാസ്: ഒന്നിലധികം വാങ്ങുക.സാധുത കാലയളവ് നീട്ടുന്നതിനുള്ള പാസുകൾ (ഉദാ. 2 = 14 ദിവസം വാങ്ങുക)',
      sub4paragraph2:
        'ഒന്നിലധികം തരം പ്രതിവാര കാർഡുകൾ: ഒരേ സമയം 3 തരം പ്രതിവാര കാർഡുകൾ സജീവമാക്കാം, കൂടാതെ റിവാർഡുകൾ സൂപ്പർഇമ്പോസ് ചെയ്യപ്പെടും.',
      sub4example:
        '(ഉദാഹരണം: ആദ്യ ദിവസം കാർഡ് A വാങ്ങുക, രണ്ടാം ദിവസം കാർഡ് B വാങ്ങുക → രണ്ടാം ദിവസം മുതൽ A+Brewards രണ്ടും ആസ്വദിക്കൂ)',
      subtitle5: 'വിഐപി എക്സ്ക്ലൂസീവ്',
      sub5paragraph1:
        'VIP ഉപയോക്താക്കൾക്ക് മാത്രമേ ഇത് കാണാനോ വാങ്ങാനോ കഴിയൂ.ഉൽപ്പന്നം, വിഐപി അല്ലാത്ത ഉപയോക്താക്കൾക്ക് ഇത് ഉപയോഗിക്കാൻ കഴിയില്ല',
      sub5paragraph2:
        'തിങ്കളാഴ്ച [ഗോൾഡൻ വീക്ക് കാർഡ്] വാങ്ങുക → അടുത്ത തിങ്കളാഴ്ച വരെ എല്ലാ ദിവസവും സ്വർണ്ണ റിവാർഡുകൾ നേടൂ',
      sub5paragraph3:
        'വെള്ളിയാഴ്ച വീണ്ടും അതേ ഇനം വാങ്ങുക → സാധുത കാലയളവ് അടുത്ത ഞായറാഴ്ച വരെ നീട്ടിയിരിക്കുന്നു, റിവാർഡ് ഇപ്പോഴും ക്ലെയിം ചെയ്യാൻ കഴിയും.',
      sub5remark1:
        'ക്ലെയിം ചെയ്യുന്നതിന് ദിവസവും ലോഗിൻ ചെയ്യാൻ ശുപാർശ ചെയ്യുന്നു പ്രതിവാര കാർഡിന്റെ പ്രതിഫലങ്ങൾ നേടുകയും പരമാവധി പ്രയോജനപ്പെടുത്തുകയും ചെയ്യുക!',
      sub5remark2: 'നിങ്ങൾക്ക് എന്തെങ്കിലും ചോദ്യങ്ങളുണ്ടെങ്കിൽ, ദയവായി കസ്റ്റമർ സർവീസ്  ബന്ധപ്പെടുക',
    },
    table: {
      level: 'വിഐപി ലെവൽ',
      reward: 'പ്രതിഫലം',
      bouns: 'ബോണസ്',
      spin: 'സ്പിൻ',
    },
    success: 'വിജയകരമായി',
    rechargeTip: 'ലെവൽ {{level}} എത്താൻ <0>{{price}}</0> കൂടുതൽ റീചാർജ് ചെയ്യുക',
    incoming: 'ഈ ലെവലിൽ എത്തിയ ശേഷം, മറഞ്ഞിരിക്കുന്ന ലെവൽ അൺലോക്ക് ചെയ്യപ്പെടും.',
  },
  referral: {
    copy: 'പകർത്തുക',
    invite: 'ക്ഷണിക്കുക',
    copied: 'വിജയകരമായി',
  },
  luckyspin: {
    add: 'ആഡ് ചെയ്യുക',
    spin: 'സ്പിൻ',
    won: 'ജയിച്ചു',
    winner: 'വലിയ വിജയികൾ',
    mySpin: 'എൻ്റെ സ്പിൻ',
    free: 'സൗജന്യം',
    myfree: 'എന്റെ സൗജന്യ സ്പിൻ',
    morefree: 'കൂടുതൽ സൗജന്യം',
    vip: 'വിഐപി',
    usefreefirst: 'ദയവായി ഒഴിവു സമയം ആദ്യം ഉപയോഗിക്കുക',
  },
  'error-pages': {
    refresh: {
      label: {
        title: 'പിശക്!',
        'sub-title': 'ദയവായി നിങ്ങളുടെ പേജ് പുതുക്കുക',
        'try-again': 'വീണ്ടും ശ്രമിക്കുക',
      },
    },
    'no-data': {
      label: {
        title: 'ഡാറ്റ ലഭ്യമല്ല',
      },
    },
    'not-found': {
      label: {
        title: 'നിലവിലെ നെറ്റ്‌വർക്ക് സിഗ്നൽ മോശമാണ്',
        'sub-title': 'ദയവായി നിങ്ങളുടെ നെറ്റ്‌വർക്ക് പരിശോധിക്കുക',
      },
    },
    'no-result': {
      label: {
        title: 'തിരയൽ ഫലമില്ല!',
      },
    },
  },
  share: {
    copy: 'പകർത്തുക',
    invite: 'ക്ഷണിക്കുക',
    'copy-success': 'വിജയകരമായി പകർത്തി',
    copied: 'വിജയകരമായി പകർത്തിയിരിക്കുന്നു',
  },
  casino: {
    big: 'വലുത്‌',
    win: 'വിജയിക്കുക',
    detail: {
      title: 'വിജയികൾക്ക്  അഭിനന്ദനങ്ങൾ',
    },
    winPrize: 'വിജയിച്ച സമ്മാനം',
    playnow: 'ഇപ്പോൾ കളിക്കുക',
  },
  login: {
    label: {
      login: 'ലോഗിൻ',
      skip: 'ഒഴിവാക്കുക',
      sign: 'സൈൻ അപ്പ് ചെയ്യുക',
      next: 'അടുത്തത്',
      'select-region': 'പ്രദേശം തിരഞ്ഞെടുക്കുക',
      'otp-login': 'OTP ലോഗിൻ',
      'password-login': 'പാസ്‌വേഡ് ലോഗിൻ',
      'get-otp': 'OTP നേടുക',
      'set-password': 'പാസ്‌വേഡ് സജ്ജമാക്കുക',
    },
    tip: {
      'no-phone': 'ദയവായി ഫോൺ നമ്പർ നൽകുക',
      'no-password': 'ദയവായി പാസ്‌വേഡ് നൽകുക',
      'no-otp': 'OTP നൽകുക',
      phone: 'ഫോൺ നമ്പർ നൽകുക',
      password: 'പാസ്‌വേഡ് നൽകുക(6-18)',
      passwordRule: '8 മുതൽ 16 വരെ അക്കങ്ങളും അക്ഷരങ്ങളും അടങ്ങിയിരിക്കണം',
      'confirm-password': 'കൺഫോം പാസ്‍വേഡ്',
      forgot: 'ഫോർഗെറ്റ് പാസ്‌വേഡ് ?',
      'new-account': 'പുതിയ അക്കൗണ്ട്?',
      'sing-in': 'സൈൻ ചെയ്യുക',
      otp: 'OTP നൽകുക',
      'referral-code': 'റെഫറൽ കോഡ്',
      confrim18: 'ഞാൻ 18+ ആണെന്ന് സ്ഥിരീകരിക്കുന്നു',
      'allow-notify':
        'ഈ ഫോൺ നമ്പറിലൂടെ പ്രധാനപ്പെട്ട വിജയകരമായ വിവരങ്ങൾ നിങ്ങളെ അറിയിക്കാൻ ഞങ്ങളെ അനുവദിക്കുക.',
      'has-account': 'മുൻ ഉഭഭോക്താവാണ്?',
      'sign-in': 'ലോഗിൻ',
      page18: 'ഞാൻ 18+ ആണെന്ന് സ്ഥിരീകരിക്കുന്നു',
      'pwd-dif': 'പാസ്‌വേഡുകൾ പൊരുത്തമില്ലാത്തതാണ്',
      notify:
        'ഈ മൊബൈൽ നമ്പറിലൂടെ പ്രധാനപ്പെട്ട വിജയകരമായ വിവരങ്ങൾ നിങ്ങളെ അറിയിക്കാൻ ഞങ്ങളെ അനുവദിക്കുക.',
      modified: 'പാസ്‌വേഡ് വിജയകരമായി പൂർത്തികരിച്ചിരിക്കുന്നു . ദയവായി വീണ്ടും ലോഗിൻ ചെയ്യുക',
      'game-not-active':
        'ക്ഷമിക്കണം, ഗെയിം പരിപാലനത്തിലാണ്‌. ദയവായി വീണ്ടും ശ്രമിക്കുക',
    },
  },
  paidSuccess: {
    label: {
      title: 'പേയ്മെന്റ്റ്',
      subTitle: 'വിജയകരമായി',
      viewOrder: 'ഓർഡർ കാണുക',
      backHome: 'തിരികെ ഹോം പേജിലേക്',
    },
    tip: {
      msg: 'നിങ്ങൾ ടിക്കറ്റ് വിജയകരമായി വാങ്ങി. നറുക്കെടുപ്പ് സമയം ശ്രദ്ധിക്കുകയും ഫലങ്ങൾ ഉടനടി പരിശോധിക്കുകയും ചെയ്യുക',
    },
  },
  splash: {
    tip: {
      checkingResources: 'റിസോഴ്സ് പരിശോധിയ്ക്കുന്നു ...',
      checkingVersion: 'വേർഷൻ പരിശോധിയ്ക്കുന്നു...',
      downloading: 'റിസോഴ്സ് പരിശോധിയ്ക്കുന്നു...',
      resolve:
        'റിസോഴ്സ് പരിഹരിക്കുന്നു (ഈ പ്രക്രിയ നെറ്റ്‌വർക്ക് ഉപയോഗിക്കുന്നില്ല)',
      alertTitle: 'അപ്ഡേറ്റ് ലഭ്യമാണ്',
      restart: 'പുനരാരംഭിക്കുക',
      alertContent:
        'ഒരു അപ്ഡേറ്റ് ലഭ്യമാണ്. അപ്ഡേറ്റ്നു വേണ്ടിആപ്പ് റീസ്‌റ്റാർട്ട് ചെയ്യുന്നു...',
    },
  },
  recharge: {
    tip: {
      easyPaymentError:
        'സേവനം നേടുന്നതിൽ പരാജയപ്പെട്ടു, ദയവായി മറ്റ് പേയ്‌മെന്റ് രീതികളിലേയ്ക് മാറ്റുക',
    },
  },
  'recharge-page': {
    currentMethod: 'നിലവിലെ രീതി',
    label: {
      records: 'രേഖകൾ',
      min: 'ഏറ്റവും കുറഞ്ഞത്',
      max: 'പരമാവധി',
      channel: 'റീചാർജ് ചാനൽ',
      enter: 'തുക നൽകുക',
    },
    tip: {
      payMethodTip:
        'നിലവിലെ രീതി പരാജയപ്പെട്ടാൽ ദയവായി മറ്റൊരു രീതിയിലേക്ക് മാറുക.',
      'money-error': 'ശരിയായ തുക നൽകുക',
      'paymethod-error': 'പേയ്മെന്റ്-പിശക്',
    },
  },
  datePicker: {
    label: {
      select: 'തീയതി തിരഞ്ഞെടുക്കുക',
    },
  },
  rebate: {
    tabs: {
      all: 'എല്ലാം',
      finish: 'പൂർത്തിയാക്കുക',
      collect: 'ശേഖരിക്കുക',
      received: 'ലഭിച്ചു',
    },
    title: 'റിബേറ്റ്',
    filter: 'ഫിൽട്ടർ',
    undone: 'പഴയപടിയാക്കുക',
    unclaimed: 'അവകാശപ്പെടാത്തത്',
    completed: 'പൂർത്തിയാക്കി',
    unfinished: 'പൂർത്തിയാകാത്തത്',
    receive: 'സ്വീകരിക്കുക',
    received: 'ലഭിച്ചു',
    today: 'ഇന്ന്',
    yesterday: 'ഇന്നലെ',
    betting: 'കണക്കാക്കിയ ബെറ്റിങ്：',
    rebate: 'കണക്കാക്കിയ റിബേറ്റ്：',
    congratulations: 'അഭിനന്ദനങ്ങൾ！',
    'get-bonus': 'ബോണസ് നേടുക',
    rule: {
      betting: 'ബെറ്റിങ് ബോണസ്:',
      'betting-detail':
        '{{name}} ബെറ്റിങ് തുക അനുസരിച്ച് യൂസേഴ്‌സിന് ഇളവ് നൽകും.ബെറ്റിങ് എത്രയോ അത്രയും നിങ്ങൾക്ക് ലഭിക്കും.',
      activity: 'പ്രവർത്തന വിവരണം:',
      'പ്രവർത്തനം-വിശദാംശം':
        '{{name}} ബോണസ് റിബേറ്റ് പ്രവർത്തനം തുറന്നിരിക്കുന്നു. ഓരോ ബെറ്റിങ്ങിലും 1 റിബേറ്റ് ബോണസ് ലഭിക്കും. നിങ്ങൾ ജയിച്ചാലും തോറ്റാലും , ബോണസ് ലഭിക്കും.',
      actrule: 'പ്രവർത്തന നിയമങ്ങൾ:',
      'actrule-detail':
        'വാതുവെപ്പ് റിബേറ്റ് ബോണസ് ഡെയ്‌ലിബോണസ് ക്ലെയിം സമയം അടുത്ത ദിവസം 00:30 ന് ശേഷമായിരിക്കും.',
      precaution: 'Precautions:',
      'precaution-detail-1':
        '-യോഗ്യതയുള്ളവർ മാത്രം {{name}} അംഗങ്ങൾക്ക് പ്രവർത്തനങ്ങളിൽ പങ്കെടുക്കാം റിബേറ്റ് ബോണസ് ക്ലെയിം ചെയ്യുന്നതിന് ഓരോ അംഗവും സിങ്കം അക്കൗണ്ടിലെ അക്കൗണ്ട് വിശദാംശങ്ങൾ പൂർത്തിയാക്കണം.- നിയമവിരുദ്ധ പ്രവർത്തനങ്ങളിൽ ഏർപ്പെട്ടിരിക്കുന്ന ഏതൊരു ഉപയോക്താവും കർശനമായി നിരോധിച്ചിരിക്കുന്നു',
      'precaution-detail-2':
        '-സെയിം നമ്പർ , ബാങ്ക് അക്കൗണ്ട് നമ്പർ. ഇമെയിൽ വിലാസവും ഐപി വിലാസവും ഒന്നിലധികം അക്കൗണ്ടുകൾക്കായി ഉപയോഗിക്കാൻ കഴിയില്ല',
      'precaution-detail-3':
        '-{{name}}ബോണസ് പ്രയോജനപ്പെടുത്തി വ്യക്തികളോ ഗ്രൂപ്പുകളോ നടത്തുന്ന നിയമവിരുദ്ധ/വഞ്ചനാപരമായ പ്രവർത്തനങ്ങൾ കണ്ടെത്തിയാൽ അക്കൗണ്ടുകൾ മരവിപ്പിക്കാനോ പേയ്‌മെന്റുകൾ റദ്ദാക്കാനോ അവകാശമുണ്ട്., (അന്തിമ ബോണസ് തീരുമാനം സിങ്കത്തിന്റ്റ്താണ്）',
    },
  },
  wallet: {
    title: 'എൻ്റെ വാലറ്റ്',
    total: 'ആകെ വാലറ്റ്',
    recharge: 'റീചാർജ്',
    main: 'പ്രധാന വാലറ്റ്',
    third: 'മൂന്നാം കക്ഷി വാലറ്റ്',
    transfer: 'പ്രധാന വാലറ്റ് കൈമാറ്റം',
    translation: 'വിവർത്തനം：{{second}}s',
    transComplete: 'പരിവർത്തനം പൂർത്തിയായി',
    transferNav: {
      recharge: 'റീചാർജ്',
      withdraw: 'പിൻവലിക്കുക',
      transfer: 'കൈമാറ്റം',
    },
  },
  promotion: {
    title: 'പ്രമോഷനുകൾ',
    go: 'പോകൂ',
    playNow: 'ഇപ്പോൾ കളിക്കുക',
    view: 'കാണുക',
    detail: 'പ്രവർത്തന വിശദാംശങ്ങൾ',
    join: 'ചേരുക',
    checkin: 'ചെക്ക് - ഇൻ ചെയ്യുക',
    checkinDescription: 'ധാരാളം റിവാർഡുകൾ ലഭിക്കാൻ ദിവസവും ചെക്ക് ഇൻ ചെയ്യുക',
  },
  satta: {
    title: {
      betting: 'ബെറ്റിങ്',
      rule: 'നിയമം',
      history: 'റിസൾട്ട് ഹിസ്റ്റോറി',
      order: 'എൻ്റെ ഓർഡർ',
      panel: 'പാനൽ:',
      open: 'തുറക്കുക',
      close: 'അടയ്ക്കുക',
    },
    betting: {
      ank: 'അങ്ക്',
      jodi: 'ജോഡി',
      sp: 'SP',
      dp: 'DP',
      tp: 'TP',
      half: 'പകുതി സംഗമം',
      full: 'പൂർണ്ണ സംഗമം',
      exwinning: 'പ്രതീക്ഷിച്ച വിജയം:',
      open: 'തുറക്കുക',
      close: 'അടയ്ക്കുക',
      paynow: 'പണം അടയ്ക്കുക',
      add: 'ചേർക്കുക',
      mybids: 'എൻ്റെ ബെറ്റ് ',
      bids: 'ബെറ്റുകൾ',
      tip: {
        enter: {
          amount: 'തുക ആഡ് ചെയ്യുക',
          open: 'ഓപ്പൺ ഡിജിറ്റ് നൽകുക',
          opens: 'അക്കം തുറക്കുന്നു',
          close: 'അടുത്ത അക്കം',
          closes: 'അക്കം അടയ്ക്കുന്നു',
          jodi: 'ജോഡി ഡിജിറ്റ്  നൽകുക',
          openpanna: 'പന്ന തുറക്കുക',
          closepanna: 'പന്ന അടയ്ക്കുക',
        },
        require: {
          amount: 'തുക അടയ്ക്കുക',
          open: 'ഡിജിറ്റ് തുറക്കുക',
          opens: 'ഓപ്പൺ  ഡിജിറ്റ് നൽകുക',
          close: ' ക്ലോസ് ഡിജിറ്റ് നൽകുക',
          closes: 'ഡിജിറ്റ് ക്ലോസ് ചെയ്യുക',
          jodi: 'ജോഡി ഡിജിറ്റ് ആഡ് ചെയ്യുക',
          openpanna: 'പന്ന  തുറക്കുക ആഡ് ചെയ്യുക',
          closepanna: 'പന്ന അടയ്ക്കുക ആഡ് ചെയ്യുക',
        },
        check: 'പൂർത്തിയാക്കിയ അക്കങ്ങൾ നൽകുക',
        minAmount: 'ഏറ്റവും കുറഞ്ഞ ശമ്പള തുക{{തുക}}',
      },
      digitTitle: {
        ank: 'സിംഗിൾ ഡിജിറ്റ്:',
        jodi: 'ജോഡി ഡിജിറ്റ്:',
        sp: 'സിംഗിൾ പത്തി:',
        dp: 'ഡബിൾ പത്തി:',
        tp: 'ട്രിപ്പിൾ പത്തി :',
        half: 'HS:',
        full: 'FS:',
      },
      describe: {
        ank: 'തുറക്കുക അല്ലെങ്കിൽ അടയ്ക്കുക ക്ലിക്കുചെയ്യുക, ഇൻപുട്ട് ബോക്സിൽ നിങ്ങൾക്ക് ആവശ്യമുള്ള ഒരു അക്കം നൽകുക, ഉദാഹരണത്തിന് 1',
        jodi: 'ഇൻപുട്ട് ബോക്സിൽ നിങ്ങൾ വാതുവെയ്ക്കാൻ ആഗ്രഹിക്കുന്ന രണ്ട് അക്ക നമ്പർ നൽകുക, ഉദാഹരണത്തിന് 12',
        sp: 'തുറക്കുക അല്ലെങ്കിൽ അടയ്ക്കുക ക്ലിക്കുചെയ്യുക, തുടർന്ന് ഇൻപുട്ട് ബോക്സിൽ 123 പോലെയുള്ള മൂന്ന് നമ്പറുകൾ നൽകുക.',
        dp: 'തുറക്കുക അല്ലെങ്കിൽ അടയ്ക്കുക ക്ലിക്കുചെയ്യുക, ഇൻപുട്ട് ബോക്സിൽ നിങ്ങൾ വാതുവെക്കാൻ ആഗ്രഹിക്കുന്ന മൂന്ന് നമ്പറുകൾ നൽകുക, 112 പോലുള്ള രണ്ട് സമാന നമ്പറുകൾ ഉണ്ടായിരിക്കണം',
        tp: 'തുറക്കുക അല്ലെങ്കിൽ അടയ്ക്കുക ക്ലിക്കുചെയ്യുക, 111 പോലെയുള്ള മൂന്ന് സമാന നമ്പറുകൾ നൽകുക',
        half: 'തുറക്കുക അല്ലെങ്കിൽ അടയ്ക്കുക ക്ലിക്കുചെയ്യുക, ഇൻപുട്ട് ബോക്സിൽ 123, 1,1, 123 എന്നിങ്ങനെ മൂന്നോ ഒന്നോ നമ്പർ നൽകുക',
        full: 'രണ്ട് ഇൻപുട്ട് ബോക്സുകളിൽ 123, 123 എന്നിങ്ങനെ മൂന്ന് അക്കങ്ങൾ നൽകുക',
      },
    },
  },
};
